import * as React from 'react';
import { Button, Alert } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import {ControlErrorListItem, IControlError, IControlSchema} from '../../../Controls';
import { Component, Guid } from '../../../Utils';
import { ApiClient } from '../../../../services/ApiClient';
import {IDispatcher } from '../../extensions/Dispatcher';
import { Field, ControlDynamic, ValueItem } from './types';
import PanelItem from './PanelItem';
import {Dictionary} from "../../../../types/Dictionary";
import { getFormatterNumber } from "../../../../helpers/getFormatterNumber";

export interface DynamicGridPanelShema extends IControlSchema {
  controls: Array<IControlSchema>;
  fields: Array<Field>;
  value?: Array<ValueItem>;
  disabled?: boolean;
}

interface Props {
  schema: DynamicGridPanelShema;
  api: ApiClient;
  dispatcher: IDispatcher;
  values: Array<any>;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>,
  allVisited: boolean,
}

interface State {
  values: Array<ValueItem>;
  errors?: Array<string>;
  helpShow: boolean;
}

class DynamicGridPanel extends Component<Props, State> {
  state = {
    values: [],
    errors: [],
    helpShow: false,
  }

  onChange = (id: string, values: Array<any>, total: string, ref: boolean) => {
    const old = [...this.state.values];
    const index = this.state.values.findIndex(t => t.id === id);

    if (index > -1) {
      old[index].values = values;
      old[index].total = total;

      this.setState({ values: old });

      //if(ref){
      this.props.dispatcher.onAddValueRefresh(this.props.schema.id, old, undefined);
      //}
    }
  }

  onAddion = () => {
    const row = {
      id: Guid.newGuid(),
      values: [],
      fields: [...this.props.schema.fields],
      items: [],
      closed: false,
      total: null
    }
    this.setState({ values: [...this.state.values, row] });
    this.props.dispatcher.onBlur(this.props.schema.id, [...this.state.values, row], true, undefined);
  }
  onRemove = (id: string) => {
    const values = this.state.values.filter(t => t.id !== id);

    if (window.confirm("Вы действительно хотите удалить блок ?")) {

      this.props.api.hasRemoveBlock(id, {
        success: (data) => {
          if (data.isRemove === '1') {
            this.setState({ values });
            this.props.dispatcher.onAddValueRefresh(this.props.schema.id, isEmpty(values) ? null : values, undefined);
          } else {
            this.setState({ errors: [...this.state.errors, id ] });
          }
        }
      });
    }
  }

  onCloused = (id: string) => {
    const baseId = Date.now();
    const mapCtrl = new Array<ControlDynamic>();
    const values = [...this.state.values]
    const index = values.findIndex(t => t.id === id);
    if (index > -1) {
      const rows = values[index].values.map(t => t['selectKey']);
      for (const row of rows) {
        for(const ctrl of this.props.schema.controls) {
          if (ctrl.rule) {
            const visible = ctrl.rule.value.split(',').indexOf(row) > -1;
            if (visible && !mapCtrl.some(t => t.id === ctrl.id)) {
              mapCtrl.push({ id: ctrl.id, name: `${ctrl.id}_copy_${baseId}`, type: ctrl.type });
            }
          } else if(!mapCtrl.some(t => t.id === ctrl.id)) {
            mapCtrl.push({ id: ctrl.id, name: `${ctrl.id}_copy_${baseId}`, type: ctrl.type });
          }
        }
      }
      values[index] = { ...values[index], closed: true, items: mapCtrl };
      this.setState({ values });
      this.props.dispatcher.onBlur(this.props.schema.id, values, true, undefined);
    }
  }
  componentDidMount() {
    if (!isEmpty(this.props.schema.value)) {
      this.setState({ values: this.props.schema.value })
    }
  }

  onHelpClick = () => this.setState(({ helpShow }) => ({ helpShow: !helpShow }));

  render() {
    const valueTotal: number = this.state.values.filter(t => t.total).reduce((s,v) => s + parseFloat(v.total),0)
    const thisError = this.props.errors[this.props.schema.id];

    return (
      <div id={this.props.schema.id}>
        <div className="text-right">
          {valueTotal > 0 && (
            <h3>
              Итого cмета: { getFormatterNumber(valueTotal.toFixed(2), true) }
            </h3>
          )}
        </div>
        {this.state.values.map(t => {
          const error = this.props.errors && this.props.errors[t.id];

          return (
            <div key={t.id} id={t.id}>
              {!t.closed && error && (
                <Alert bsStyle="danger">{error.message}</Alert>
              )}
              {this.state.errors.indexOf(t.id) > -1 && (
                <Alert bsStyle="danger">Нельзя удалить блок пока в нем есть файлы</Alert>
              )}
              <PanelItem
                id={t.id}
                fields={this.props.schema.fields}
                values={t.values}
                closed={t.closed}
                total={t.total}
                disabled={this.props.schema.disabled}
                template={this.props.schema.controls}
                elements={t.items}
                controlValues={this.props.values}
                errors={this.props.errors}
                allVisited={this.props.allVisited}
                visited={this.props.visited}
                api={this.props.api}
                dispatcher={this.props.dispatcher}
                onCloused={this.onCloused}
                onRemove={this.onRemove}
                onUpdate={this.onChange}
                onChange={this.onChange}
              />
            </div>
          );
        })}
        <div className="text-right">
          <Button bsStyle="success" disabled={this.props.schema.disabled} onClick={this.onAddion}>
            Добавить новый блок
          </Button>
          <Button bsStyle="primary" onClick={this.onHelpClick} title="Справка">
            <span className="fa fa-question-circle-o fa-fw"/>
          </Button>
        </div>

        {thisError && (
          <Alert bsStyle="danger">{thisError.message}</Alert>
        )}
        {this.state.helpShow && (
          <Alert bsStyle="warning">При составлении сметы блок расходов следует приравнивать к счету подрядчика</Alert>
        )}
      </div>
    );
  }

}

export function createDynamicGrid(
  schema: IControlSchema,
  api: ApiClient,
  dispatcher: IDispatcher = null,
  errors: Dictionary<IControlError | undefined>,
  values: any,
  visited: Dictionary<boolean>,
  allVisited: boolean) : React.ReactElement<any> {
  return (
    <DynamicGridPanel
      errors={errors}
      values={values}
      schema={schema as DynamicGridPanelShema}
      api={api}
      visited={visited}
      allVisited={allVisited}
      dispatcher={dispatcher}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/controls/standart/DynamicGridPanel/index.tsx